/* agsc (Ansen 2026-10-17, sticky cart). Phones only (768px and under).
   - A bar sits at the bottom once the page's ADD TO CART has scrolled away above, and slides off at the footer.
     It shows what is picked (size, return, finish), the price, and ADD TO CART. The chat bubble lifts above it.
   - Tapping the picks line slides up a sheet (about 70% of the screen): sizes in two rows that swipe sideways,
     the return / form drawings, the finishes in one swipe row, a + CUSTOM tile, quantity and ADD TO CART.
     Opening it scrolls the page so the product photo sits above the sheet; a return or finish pick swaps the photo
     (the page's own mobile-variant-scroll.js and gallery code do that, because the sheet presses the real controls).
   - An i beside SIZE (in the sheet and on the page) floats a card with the drawing from above and the sizes in
     feet (inches). Executive desks: the front and the return. Conference tables: length and the short side.
     Reception desks: a plain rectangle, width and depth.
   - On executive desks the page's size dropdown reads "8′ desk + 5′3″ return".
   Nothing here is a second form: every pick presses the page's own control, and ADD TO CART clicks the real button.
   Data: #agsc-data (snippets/ag-sticky-cart.liquid). Styles: ag-sticky-cart.css.
   Canvas: https://claude.ai/artifact/SEw9tVMWEFTaa5eCi6TMzU */
(function () {
  'use strict';

  var dataEl = document.getElementById('agsc-data');
  if (!dataEl || window.__agsc) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var atcBtn = document.getElementById('add-to-cart-btn');
  var vidInput = document.getElementById('product-variant-id');
  var atcWrap = atcBtn && atcBtn.closest('.product-header_add-to-cart-wrapper');
  if (!atcBtn || !vidInput || !atcWrap || !D || !D.variants || !D.variants.length) return;
  window.__agsc = true;

  var MQ = window.matchMedia('(max-width: 768px)');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- data ---------- */
  var opts = (D.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
  var findOpt = function (re, not) { for (var i = 0; i < opts.length; i++) { if (re.test(opts[i]) && !(not && not.test(opts[i]))) return i; } return -1; };
  var SIZE_I = findOpt(/^size$/i);
  var RET_I = findOpt(/return|configuration/i, /finish/i);
  var TYPE = String(D.type || '');
  var KIND = /executive/i.test(TYPE) && RET_I >= 0 ? 'L' : /conference/i.test(TYPE) ? 'table' : /reception/i.test(TYPE) ? 'desk' : null;

  function num(x) {
    if (x == null || x === '') return null;
    if (typeof x === 'number') return isFinite(x) ? x : null;
    if (typeof x === 'object' && 'value' in x) return num(x.value);
    var n = parseFloat(String(x).replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : null;
  }
  function parseWD(s) {
    var m = String(s || '').match(/([\d.]+)\s*″?\s*W[^\d]*([\d.]+)\s*″?\s*D/i);
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : [null, null];
  }
  function variantFor(sizeValue) {
    for (var i = 0; i < D.variants.length; i++) { if (SIZE_I < 0 || D.variants[i].o[SIZE_I] === sizeValue) return D.variants[i]; }
    return null;
  }
  function dimsFor(sizeValue) {
    var v = variantFor(sizeValue);
    if (!v) return null;
    var pw = parseWD(v.pi), sw = parseWD(v.si);
    var w = num(v.w) || pw[0], d = num(v.d) || pw[1], rw = num(v.rw) || sw[0], rd = num(v.rd) || sw[1];
    return w ? { w: w, d: d, rw: rw, rd: rd } : null;
  }
  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function ftIn(inches) {
    var t = Math.round(inches * 2) / 2, f = Math.floor(t / 12), r = t - f * 12;
    return f + '′' + (r ? Math.floor(r) + (r % 1 ? '½' : '') + '″' : '');
  }
  function inch(v) { return (Math.round(v * 10) / 10) + '″'; }
  // The site names sizes by the metric series (240 cm = 8′, 160 cm = 5′3″), so a return reads like the sizes do.
  var NOMINAL = { 120: '4′', 140: '4′7″', 160: '5′3″', 180: '6′', 200: '6′7″', 220: '7′3″', 240: '8′', 260: '8′6″', 280: '9′2″', 300: '10′', 320: '10′6″', 340: '11′2″', 350: '11′6″', 360: '12′', 380: '12′6″', 400: '13′' };
  function nominal(inches) { return NOMINAL[Math.round(inches * 2.54 / 10) * 10] || ftIn(inches); }
  function sizeShort(text) { var m = String(text || '').match(/^\s*(\d+′(?:\d+(?:\.\d+)?″)?)/); return m ? m[1] : ''; }
  function seats(text) { var m = String(text || '').match(/\(([^)]*seat[^)]*)\)/i); return m ? m[1] : ''; }
  function curVariant() {
    var id = String(vidInput.value || '');
    for (var i = 0; i < D.variants.length; i++) { if (String(D.variants[i].id) === id) return D.variants[i]; }
    return D.variants[0];
  }
  function priceFor(sizeValue) {
    var cur = curVariant();
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i], ok = true;
      for (var k = 0; k < v.o.length; k++) { if (k === SIZE_I ? v.o[k] !== sizeValue : v.o[k] !== cur.o[k]) { ok = false; break; } }
      if (ok) return v.price;
    }
    var any = variantFor(sizeValue);
    return any ? any.price : null;
  }

  /* ---------- the page's own controls ---------- */
  var sizeSel = $('select#size-dropdown') || $('select.product-variant-option[name="Size"]');
  var retGroup = $('.product-header_option[data-option-name="return-desk"]') || $('.product-header_option[data-option-name="reception-configuration"]') || $('.product-header_option[data-option-name="configuration"]');
  var sizeGroup = sizeSel && sizeSel.closest('.product-header_option');
  var qtyInput = document.getElementById('quantity');
  var oosBox = document.getElementById('out-of-stock-container');
  // The page's finish cards. A product with one finish shows a single display card (no picking); the sheet shows it
  // as a picked tile too, so every product shows its finish picture (Ansen, round 6).
  function finCards() { return $$('[data-finishing-mode="select"] .ag-finish-card--selectable, [data-finishing-mode="display"] .ag-finish-card--display'); }
  function isPicked(c) { return c.classList.contains('is-selected') || c.classList.contains('ag-finish-card--display'); }
  function retLabels() {
    if (!retGroup) return [];
    return $$('label.product-header_radio', retGroup).filter(function (l) { return l.querySelector('input[type="radio"]') && l.offsetParent !== null; });
  }
  function sizeOptions() { return sizeSel ? Array.prototype.slice.call(sizeSel.options).filter(function (o) { return !o.hidden && o.style.display !== 'none'; }) : []; }
  function oosShown() { return !!(oosBox && getComputedStyle(oosBox).display !== 'none'); }
  function customOn() { return !!$('[data-agcf-r6].is-agcf-custom'); }
  // The custom finish the shopper picked (agcf.js keeps it on its Custom Finishing tile, .agcf-ghost):
  // "Custom Finishing: Golden Walnut with Matte Black accent" and the swatch pictures.
  function customPick() {
    var g = $('.agcf-ghost');
    if (!g) return null;
    var m = String(g.getAttribute('aria-label') || '').match(/:\s*(.+)$/);
    var imgs = $$('img', g).map(function (i) { return i.currentSrc || i.getAttribute('src') || ''; });
    if (!m || !imgs[0]) return null;
    var am = m[1].match(/^(.*?)\s+with\s+(.*?)\s+accent$/i);
    return { name: am ? am[1] : m[1], full: am ? am[1] + ' / ' + am[2] : m[1], p: imgs[0], a: imgs[1] || '' };
  }
  // Opens the Custom Finishing chooser without picking anything. Its own tile (.agcf-ghost) re-applies a custom
  // finish once one is picked (and jumps to the photo), so then use "Change selection?" ([data-agcf-change]).
  function openChooser() {
    var band = $('.agcf-band');
    if (band && band.classList.contains('is-open')) return;
    var ch = $('[data-agcf-change]');
    if (customPick() && ch) { ch.click(); return; }
    var g = $('.agcf-ghost');
    if (g) g.click();
  }
  function pagePrice() {
    var sub = $('[data-agcf-atc-sub]');
    var t = sub && sub.textContent.trim();
    if (!t) { var m = document.getElementById('product-main-price'); t = m && m.textContent.trim(); }
    return t || money(curVariant().price);
  }
  function finName() {
    if (customOn()) { var cp = customPick(); return cp ? cp.name : 'Custom finish'; }
    var sel = finCards().filter(isPicked)[0];
    if (sel) return sel.getAttribute('data-finish-name-primary') || sel.getAttribute('data-finish-name') || '';
    var fi = findOpt(/finish/i);
    return fi >= 0 ? curVariant().o[fi] : '';
  }
  function finFull(c) {
    var p = c.getAttribute('data-finish-name-primary') || c.getAttribute('data-finish-name') || '';
    var a = c.getAttribute('data-finish-name-accent');
    return a ? p + ' / ' + a : p;
  }
  function retText(l) { var t = (l.textContent || '').replace(/\s+/g, ' ').trim(); return t || (l.querySelector('input') || {}).value || ''; }
  function shortTitle() { return String(D.title || '').split('·')[0].trim(); }

  var SIZE_LABEL = KIND === 'table' ? 'LENGTH' : 'SIZE';
  var HAS_SHEET = !!(sizeSel || retLabels().length || finCards().length);

  /* ---------- markup ---------- */
  var ICON = {
    up: '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 256 256"><polyline points="48,168 128,88 208,168" fill="none" stroke="currentColor" stroke-width="24"/></svg>',
    left: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 256 256"><polyline points="160,48 80,128 160,208" fill="none" stroke="currentColor" stroke-width="22"/></svg>',
    right: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 256 256"><polyline points="96,48 176,128 96,208" fill="none" stroke="currentColor" stroke-width="22"/></svg>',
    x: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 256 256"><path fill="currentColor" d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>',
    i: '<svg aria-hidden="true" width="15" height="15" viewBox="0 0 256 256"><circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" stroke-width="16"/><line x1="128" y1="120" x2="128" y2="176" stroke="currentColor" stroke-width="18"/><circle cx="128" cy="84" r="12" fill="currentColor"/></svg>',
    bell: '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 256 256"><path fill="currentColor" d="M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"/></svg>'
  };
  var TRACE = '<svg class="agsc-tr" aria-hidden="true"><rect x="0" y="0" width="100%" height="100%" pathLength="100"/></svg>';
  var ARROWS = '<button type="button" class="agsc-nav agsc-nav--prev" aria-label="Scroll back" hidden>' + ICON.left + '</button>' +
    '<button type="button" class="agsc-nav agsc-nav--next" aria-label="Scroll for more" hidden>' + ICON.right + '</button>';
  var CHAIR = '<rect width="24" height="6" rx="2"/><rect x="2" y="7" width="20" height="17" rx="3"/>';
  var ARMCHAIR = CHAIR + '<rect x="-2" y="10" width="3" height="11" rx="1"/><rect x="23" y="10" width="3" height="11" rx="1"/>';
  // The drawings from the collection pages' "how we measure" card (snippets/ag-facet-info.liquid), with the sizes
  // as text over them. Executive: the front and the return (the return line runs down to the front of the desk).
  var ART = {
    L: { vb: '-24 0 344 162', a: [53.49, 90.74], b: [13.66, 45.68, 'left'],
      svg: '<g class="agsc-ln"><rect x="40" y="14" width="54" height="64"/><rect x="43" y="17" width="48" height="58"/><rect x="40" y="78" width="240" height="56"/><rect x="43" y="81" width="234" height="50"/><rect x="196" y="89" width="26" height="9"/><rect x="199" y="91.5" width="20" height="4"/><g transform="translate(144,34) scale(1.3)">' + ARMCHAIR + '</g></g>' +
        '<g class="agsc-dm"><line x1="40" y1="138" x2="40" y2="156"/><line x1="280" y1="138" x2="280" y2="156"/><line x1="48" y1="147" x2="272" y2="147"/><line x1="22" y1="14" x2="38" y2="14"/><line x1="22" y1="134" x2="38" y2="134"/><line x1="29" y1="24" x2="29" y2="124"/></g>' +
        '<g class="agsc-hd"><polygon points="40,147 52,141 52,153"/><polygon points="280,147 268,141 268,153"/><polygon points="29,14 23,26 35,26"/><polygon points="29,134 23,122 35,122"/></g>' },
    table: { vb: '0 0 362 162', a: [44.2, 90.12], b: [87.57, 43.83, 'right'],
      svg: '<g class="agsc-ln"><rect x="50" y="40" width="220" height="62"/><rect x="53" y="43" width="214" height="56"/><rect x="146" y="66" width="28" height="10"/><rect x="149" y="68.5" width="22" height="5"/>' +
        '<g transform="translate(78,12)">' + CHAIR + '</g><g transform="translate(123,12)">' + CHAIR + '</g><g transform="translate(173,12)">' + CHAIR + '</g><g transform="translate(218,12)">' + CHAIR + '</g>' +
        '<g transform="translate(78,106) rotate(180 12 12)">' + CHAIR + '</g><g transform="translate(123,106) rotate(180 12 12)">' + CHAIR + '</g><g transform="translate(173,106) rotate(180 12 12)">' + CHAIR + '</g><g transform="translate(218,106) rotate(180 12 12)">' + CHAIR + '</g>' +
        '<g transform="translate(20,59) rotate(-90 12 12)">' + CHAIR + '</g><g transform="translate(276,59) rotate(90 12 12)">' + CHAIR + '</g></g>' +
        '<g class="agsc-dm"><line x1="50" y1="134" x2="50" y2="156"/><line x1="270" y1="134" x2="270" y2="156"/><line x1="58" y1="146" x2="262" y2="146"/><line x1="274" y1="40" x2="318" y2="40"/><line x1="274" y1="102" x2="318" y2="102"/><line x1="312" y1="50" x2="312" y2="92"/></g>' +
        '<g class="agsc-hd"><polygon points="50,146 62,140 62,152"/><polygon points="270,146 258,140 258,152"/><polygon points="312,40 306,52 318,52"/><polygon points="312,102 306,90 318,90"/></g>' },
    desk: { vb: '-24 0 344 162', a: [53.49, 90.74], b: [13.66, 62.35, 'left'],
      svg: '<g class="agsc-ln"><rect x="40" y="68" width="240" height="42"/><rect x="43" y="71" width="234" height="36"/><rect class="agsc-counter" x="40" y="110" width="240" height="24"/><rect class="agsc-counter" x="43" y="113" width="234" height="18"/><rect x="138" y="74" width="46" height="5" rx="1"/><rect x="157" y="79" width="8" height="5"/><rect x="142" y="90" width="38" height="10" rx="1"/><line x1="145" y1="95" x2="177" y2="95"/><g transform="translate(146,30) scale(1.2)">' + ARMCHAIR + '</g></g>' +
        '<g class="agsc-dm"><line x1="40" y1="138" x2="40" y2="156"/><line x1="280" y1="138" x2="280" y2="156"/><line x1="48" y1="147" x2="272" y2="147"/><line x1="20" y1="68" x2="38" y2="68"/><line x1="20" y1="134" x2="38" y2="134"/><line x1="29" y1="78" x2="29" y2="124"/></g>' +
        '<g class="agsc-hd"><polygon points="40,147 52,141 52,153"/><polygon points="280,147 268,141 268,153"/><polygon points="29,68 23,80 35,80"/><polygon points="29,134 23,122 35,122"/></g>' }
  };

  function cardLabels() {
    var opt = sizeSel && sizeSel.options[sizeSel.selectedIndex];
    var dm = opt ? dimsFor(opt.value) : null;
    if (!KIND || !dm) return null;
    var aFt = sizeShort(opt.text) || ftIn(dm.w);
    if (KIND === 'L') return dm.rw ? { aFt: aFt, aIn: inch(dm.w), bFt: nominal(dm.rw), bIn: inch(dm.rw) } : null;
    return dm.d ? { aFt: aFt, aIn: inch(dm.w), bFt: ftIn(dm.d), bIn: inch(dm.d) } : null;
  }
  function cardHTML(where) {
    var art = ART[KIND];
    return '<button type="button" class="agsc-card-x" aria-label="Close">' + ICON.x + '</button>' +
      '<div class="agsc-art"><svg viewBox="' + art.vb + '" role="img" aria-hidden="true">' + art.svg + '</svg>' +
      '<span class="agsc-lab-a" style="left:' + art.a[0] + '%;top:' + art.a[1] + '%"><b data-agsc="aFt"></b> <i data-agsc="aIn"></i></span>' +
      '<span class="agsc-lab-b agsc-lab-b--' + art.b[2] + '" style="left:' + art.b[0] + '%;top:' + art.b[1] + '%"><b data-agsc="bFt"></b><i data-agsc="bIn"></i></span></div>' +
      '<span class="agsc-sr" data-agsc="sr" id="agsc-sr-' + where + '"></span>';
  }

  var root = document.createElement('div');
  root.className = 'agsc-root';
  root.innerHTML =
    '<div class="agsc-bar" aria-hidden="true">' +
      '<button type="button" class="agsc-picks"' + (HAS_SHEET ? ' aria-haspopup="dialog" aria-label="Change your options"' : ' tabindex="-1"') + '>' +
        '<span class="agsc-picks-line"><span class="agsc-picks-txt"></span>' + (HAS_SHEET ? ICON.up : '') + '</span>' +
        '<span class="agsc-price"></span></button>' +
      '<button type="button" class="agsc-add">' + ICON.bell + '<span class="agsc-add-txt"></span></button>' +
    '</div>' +
    (HAS_SHEET ?
      '<div class="agsc-dim" aria-hidden="true"></div>' +
      '<div class="agsc-sheet" role="dialog" aria-modal="true" aria-label="Choose your options" aria-hidden="true">' +
        '<div class="agsc-catch" aria-hidden="true"></div>' +
        '<div class="agsc-handle" aria-hidden="true"><span></span></div>' +
        '<div class="agsc-head">' + (D.image ? '<img class="agsc-thumb" alt="" src="' + esc(D.image) + '">' : '') +
          '<div class="agsc-head-txt"><span class="agsc-name">' + esc(shortTitle()) + '</span><span class="agsc-hprice"></span></div>' +
          '<button type="button" class="agsc-x" aria-label="Close">' + ICON.x + '</button></div>' +
        '<div class="agsc-body">' +
          (sizeSel ? '<section class="agsc-sec"><div class="agsc-lab-row"><span class="agsc-lab">' + SIZE_LABEL + '</span>' +
            (KIND ? '<button type="button" class="agsc-i" aria-label="Size details" aria-expanded="false">' + ICON.i + '</button>' +
              '<div class="agsc-card" role="dialog" aria-label="Size details" aria-hidden="true">' + cardHTML('sheet') + '</div>' : '') +
            '</div><div class="agsc-rail-wrap"><div class="agsc-rail agsc-rail--size" data-rail="size"></div>' + ARROWS + '</div></section>' : '') +
          (retGroup ? '<section class="agsc-sec agsc-sec--ret"><span class="agsc-lab">' + esc(((retGroup.querySelector('h2') || {}).textContent || 'Return').trim()) + '</span><div class="agsc-rets"></div></section>' : '') +
          '<section class="agsc-sec agsc-sec--fin"><span class="agsc-lab">Finish</span>' +
            '<div class="agsc-rail-wrap"><div class="agsc-rail agsc-rail--fin" data-rail="fin"></div>' + ARROWS + '</div><span class="agsc-fin-name"></span></section>' +
        '</div>' +
        '<div class="agsc-foot"><div class="agsc-qty"><button type="button" class="agsc-qm" aria-label="Decrease quantity">−</button><span class="agsc-qn">1</span><button type="button" class="agsc-qp" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="agsc-add2">' + ICON.bell + '<span class="agsc-add-txt"></span></button></div>' +
      '</div>' : '');
  document.body.appendChild(root);

  var bar = $('.agsc-bar', root), sheet = $('.agsc-sheet', root), dim = $('.agsc-dim', root);
  var html = document.documentElement;

  /* ---------- the i on the page, beside the size select ---------- */
  var pageCard = null, pageI = null;
  if (KIND && sizeGroup) {
    var h2 = sizeGroup.querySelector('h2');
    if (h2) {
      pageI = document.createElement('button');
      pageI.type = 'button';
      pageI.className = 'agsc-i agsc-pi';
      pageI.setAttribute('aria-label', 'Size details');
      pageI.setAttribute('aria-expanded', 'false');
      pageI.innerHTML = ICON.i;
      h2.appendChild(pageI);
      pageCard = document.createElement('div');
      pageCard.className = 'agsc-card agsc-pcard';
      pageCard.setAttribute('role', 'dialog');
      pageCard.setAttribute('aria-label', 'Size details');
      pageCard.setAttribute('aria-hidden', 'true');
      pageCard.innerHTML = cardHTML('page');
      sizeGroup.classList.add('agsc-has-pcard');
      sizeGroup.appendChild(pageCard);
    }
  }

  /* ---------- sheet contents ---------- */
  var railSize = $('[data-rail="size"]', root), railFin = $('[data-rail="fin"]', root), retsBox = $('.agsc-rets', root);
  function buildSheet() {
    if (!sheet) return;
    sheet.classList.add('agsc-static');
    if (railSize) {
      var so = sizeOptions();
      // up to 3 sizes: one row side by side; 4: two by two; more: columns of two, top to bottom, swiped 3 at a time
      // (Ansen, round 6)
      railSize.classList.toggle('agsc-rail--row', so.length <= 3);
      railSize.classList.toggle('agsc-rail--wide', so.length === 4);
      railSize.style.setProperty('--agsc-n', Math.max(2, so.length));
      railSize.innerHTML = so.map(function (o) {
        // Executive desks: "8′ desk / + 5′3″ return" in the sheet (Ansen, round 3); the page's size row keeps its own words
        var orig = o.text;
        var dm = dimsFor(o.value);
        var short = sizeShort(orig);
        var top = short ? (KIND === 'L' ? short + ' desk' : short) : orig;
        var sub = KIND === 'L' ? (dm && dm.rw ? '+ ' + nominal(dm.rw) + ' return' : '') : KIND === 'table' ? seats(orig) : '';
        return '<button type="button" class="agsc-chip" data-v="' + esc(o.value) + '"' + (o.disabled ? ' disabled' : '') + '>' +
          '<span class="agsc-chip-a">' + esc(top) + '</span>' + (sub ? '<span class="agsc-chip-b">' + esc(sub) + '</span>' : '') +
          '<span class="agsc-chip-p"></span>' + TRACE + '</button>';
      }).join('');
    }
    if (retsBox) {
      var ls = retLabels();
      retsBox.innerHTML = ls.map(function (l, i) {
        var img = l.querySelector('img');
        var src = img ? (img.currentSrc || img.getAttribute('src') || '') : '';
        return '<button type="button" class="agsc-ret" data-i="' + i + '">' + (src ? '<img alt="" src="' + esc(src) + '">' : '') +
          '<span>' + esc(retText(l)) + '</span>' + TRACE + '</button>';
      }).join('');
      $('.agsc-sec--ret', root).hidden = ls.length < 2;
    }
    if (railFin) {
      var cs = finCards();
      var custom = $('.agcf-ghost');
      railFin.innerHTML = cs.map(function (c, i) {
        var p = c.getAttribute('data-finish-large-primary') || c.getAttribute('data-finish-large') || '';
        var a = c.getAttribute('data-has-accent') === 'true' ? c.getAttribute('data-finish-large-accent') : '';
        return '<button type="button" class="agsc-fin" data-i="' + i + '" aria-label="' + esc(finFull(c)) + '">' +
          (p ? '<img class="agsc-fin-p" alt="" src="' + esc(p) + '">' : '') + (a ? '<img class="agsc-fin-a" alt="" src="' + esc(a) + '">' : '') + TRACE + '</button>';
      }).join('') + (cs.length && custom ?
        '<button type="button" class="agsc-fin agsc-fin--mine" hidden><img class="agsc-fin-p" alt=""><img class="agsc-fin-a" alt="" hidden>' + TRACE + '</button>' +
        '<button type="button" class="agsc-fin agsc-fin--custom" aria-label="Choose a custom finish"><span>+</span><small>Custom</small></button>' : '');
      $('.agsc-sec--fin', root).classList.toggle('agsc-fixed', !cs.length);
    }
    setTimeout(function () { sheet.classList.remove('agsc-static'); }, 60);
    sync();
  }

  /* ---------- keeping everything in step with the page ---------- */
  var pending = false;
  function sync() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; doSync(); });
  }
  function setSel(el, on) {
    if (el.classList.contains('is-sel') === on) return;
    el.classList.toggle('is-sel', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function doSync() {
    var price = pagePrice();
    var opt = sizeSel && sizeSel.options[sizeSel.selectedIndex];
    var bits = [];
    if (opt) bits.push((sizeShort(opt.text) || opt.value).toUpperCase());
    var rl = retLabels(), selRet = rl.filter(function (l) { return l.querySelector('input').checked; })[0];
    if (selRet && rl.length > 1) bits.push(retText(selRet).toUpperCase());
    var fn = finName();
    if (fn) bits.push(fn.toUpperCase());
    var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var picks = (q > 1 ? 'QTY ' + q + ' · ' : '') + (bits.length ? bits.join(' · ') : shortTitle().toUpperCase());
    var oos = oosShown();
    var realTxt = (($('.add-to-cart-text', atcBtn) || atcBtn).textContent || 'Add to cart').trim();
    var addTxt = oos ? 'Notify me' : realTxt;

    $('.agsc-picks-txt', root).textContent = picks;
    $('.agsc-price', root).textContent = price;
    $$('.agsc-add, .agsc-add2', root).forEach(function (b) {
      b.classList.toggle('is-notify', oos);
      b.disabled = !oos && atcBtn.disabled;
      $('.agsc-add-txt', b).textContent = b.classList.contains('agsc-add2') && !oos ? addTxt + '  ·  ' + price : addTxt;
    });

    if (sheet) {
      $('.agsc-hprice', root).textContent = price;
      $('.agsc-qn', root).textContent = q;
      $$('.agsc-chip', root).forEach(function (c) {
        var v = c.getAttribute('data-v');
        setSel(c, !!opt && v === opt.value);
        var pc = priceFor(v);
        var pe = $('.agsc-chip-p', c);
        var t = pc != null ? money(pc) : '';
        if (pe.textContent !== t) pe.textContent = t;
      });
      $$('.agsc-ret', root).forEach(function (b) {
        var l = rl[+b.getAttribute('data-i')];
        setSel(b, !!(l && l.querySelector('input').checked));
      });
      var cs = finCards(), cus = customOn(), cp = customPick();
      var mine = $('.agsc-fin--mine', root);
      if (mine) {
        // the shopper's own custom finish, as a tile they can pick again (Ansen: the sheet should say Golden Walnut)
        mine.hidden = !cp;
        if (cp) {
          var mp = $('.agsc-fin-p', mine), ma = $('.agsc-fin-a', mine);
          if (mp.getAttribute('src') !== cp.p) mp.setAttribute('src', cp.p);
          ma.hidden = !cp.a;
          if (cp.a && ma.getAttribute('src') !== cp.a) ma.setAttribute('src', cp.a);
          mine.setAttribute('aria-label', 'Custom finish: ' + cp.full);
        }
      }
      $$('.agsc-fin', root).forEach(function (b) {
        if (b.classList.contains('agsc-fin--custom')) return;
        if (b.classList.contains('agsc-fin--mine')) { setSel(b, cus && !!cp); return; }
        var c = cs[+b.getAttribute('data-i')];
        setSel(b, !cus && !!(c && isPicked(c)));
      });
      var selCard = cs.filter(isPicked)[0];
      $('.agsc-fin-name', root).textContent = cus ? (cp ? cp.full : 'Custom finish') : selCard ? finFull(selCard) : fn;
    }
    var lab = cardLabels();
    $$('.agsc-card', document).forEach(function (card) {
      ['aFt', 'aIn', 'bFt', 'bIn'].forEach(function (k) {
        var el = $('[data-agsc="' + k + '"]', card);
        if (!el) return;
        var t = lab ? (k.slice(-2) === 'In' ? '(' + lab[k] + ')' : lab[k]) : '';
        if (el.textContent !== t) el.textContent = t;
      });
      var sr = $('[data-agsc="sr"]', card);
      if (sr) sr.textContent = lab ? (KIND === 'L' ? 'Desk ' + lab.aFt + ' (' + lab.aIn + '), return ' + lab.bFt + ' (' + lab.bIn + ')' : lab.aFt + ' (' + lab.aIn + ') by ' + lab.bFt + ' (' + lab.bIn + ')') : '';
    });
    $$('.agsc-i', document).forEach(function (b) { b.hidden = !lab; });
    updateBar();
  }

  /* ---------- the bar: after you pass the page's button, gone at the footer ---------- */
  var st = { passed: false, footer: false, drawer: false, sheet: false };
  function updateBar() {
    var show = MQ.matches && st.passed && !st.footer && !st.drawer;
    if (st.sheet) show = MQ.matches;
    bar.classList.toggle('is-on', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if ('inert' in bar) bar.inert = !show;
    html.classList.toggle('agsc-bar-on', show && !st.sheet);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { st.passed = !e.isIntersecting && e.boundingClientRect.bottom < 0; });
      updateBar();
    }).observe(atcWrap);
    var footer = $('footer') || $('.section_footer') || $('[id$="__footer"]');
    if (footer) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { st.footer = e.isIntersecting; });
        updateBar();
      }).observe(footer);
    }
  }
  var drawer = document.getElementById('cart-drawer') || $('cart-drawer');
  if (drawer) {
    var watchDrawer = function () { st.drawer = /--open|is-open|active/.test(drawer.className) || drawer.hasAttribute('open'); updateBar(); };
    new MutationObserver(watchDrawer).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    watchDrawer();
  }

  /* ---------- open / close the sheet ---------- */
  var lastFocus = null;
  // While the sheet is open, a pick there must move the page once. The page's own mobile-variant-scroll.js (and the
  // custom finish code) scroll up to the photo on every return / finish change, and then the sheet scrolled back
  // down: up, then down (Ansen, round 4). So for a moment after a sheet pick, other scripts' page scrolls are
  // ignored and the sheet places the photo itself. Nothing changes while the sheet is closed.
  var nativeScrollTo = window.scrollTo;
  var nativeIntoView = Element.prototype.scrollIntoView;
  var quietUntil = 0;
  function quiet(ms) { quietUntil = Date.now() + ms; }
  function hushed() { return st.sheet && Date.now() < quietUntil; }
  window.scrollTo = function () { if (hushed()) return; return nativeScrollTo.apply(window, arguments); };
  Element.prototype.scrollIntoView = function () { if (hushed()) return; return nativeIntoView.apply(this, arguments); };
  // Where the page sits while the sheet is open: the photo's top PHOTO_TUCK tucked under the header, so the view
  // starts that far down the photo (Ansen: 25% in round 4, 35% in round 5).
  var PHOTO_TUCK = 0.35;
  function galleryTarget() {
    var g = $('.slick-product-gallery-container .slick-product-gallery') || $('.slick-product-gallery-container');
    if (!g) return null;
    var hdr = $('.section_navbar');
    var under = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 48;
    var r = g.getBoundingClientRect();
    return Math.max(0, Math.round(window.pageYOffset + r.top + r.height * PHOTO_TUCK - under));
  }
  function alignPhoto() {
    if (!st.sheet) return;
    var y = galleryTarget();
    if (y != null && Math.abs(y - window.pageYOffset) > 3) nativeScrollTo.call(window, { top: y, behavior: 'smooth' });
  }
  function openSheet() {
    if (!sheet || st.sheet) return;
    lastFocus = document.activeElement;
    st.sheet = true;
    buildSheet();
    sheet.classList.add('is-open');
    dim.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    html.classList.add('agsc-sheet-on');
    updateBar();
    alignPhoto();
    setTimeout(function () { var x = $('.agsc-x', sheet); if (x) x.focus({ preventScroll: true }); }, 50);
    setTimeout(function () { peek(railSize); }, 380);
    setTimeout(function () { peek(railFin); }, 760);
  }
  // After a return or finish pick (other scripts' scrolls are hushed by quiet()), place the photo once, and check
  // again when things settle in case the gallery changed height.
  function keepPhoto() {
    alignPhoto();
    setTimeout(alignPhoto, 650);
  }
  function closeSheet() {
    if (!sheet || !st.sheet) return;
    st.sheet = false;
    closeCards();
    sheet.classList.remove('is-open');
    dim.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    html.classList.remove('agsc-sheet-on');
    updateBar();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- swipe rows: the arrow on the right, a nudge on open so people see they scroll ---------- */
  function railArrows(rail) {
    if (!rail) return;
    var wrap = rail.parentNode, max = rail.scrollWidth - rail.clientWidth;
    $('.agsc-nav--prev', wrap).hidden = !(max > 4 && rail.scrollLeft > 4);
    $('.agsc-nav--next', wrap).hidden = !(max > 4 && rail.scrollLeft < max - 4);
  }
  function peek(rail) {
    if (!rail || rail.scrollWidth <= rail.clientWidth + 4 || !st.sheet) { railArrows(rail); return; }
    // open on the page of 3 that holds the picked tile
    var sel = $('.is-sel', rail), cols = railCols(rail), max = rail.scrollWidth - rail.clientWidth, at = 0;
    cols.forEach(function (c, i) { if (sel && c.l === sel.offsetLeft) at = i; });
    var target = Math.min(max, cols[Math.floor(at / 3) * 3].l - cols[0].l);
    rail.scrollLeft = target;
    railArrows(rail);
    setTimeout(function () { rail.scrollTo({ left: target + 48, behavior: 'smooth' }); }, 150);
    setTimeout(function () { rail.scrollTo({ left: target, behavior: 'smooth' }); }, 650);
  }
  [railSize, railFin].forEach(function (rail) {
    if (!rail) return;
    rail.addEventListener('scroll', function () { railArrows(rail); }, { passive: true });
    var wrap = rail.parentNode;
    $('.agsc-nav--next', wrap).addEventListener('click', function () { railStep(rail, 1); });
    $('.agsc-nav--prev', wrap).addEventListener('click', function () { railStep(rail, -1); });
  });
  // The arrows page the row by 3 (Ansen, round 5): it shows exactly 3 tiles, and every arrow lands with a whole
  // tile at the left margin, or at the row's end. The target is always a real tile position inside the row: the old
  // "scroll back 65%" asked for a spot left of the start after a small swipe, and iPhones drew that as blank space.
  // A size column (two chips) counts as one tile.
  function railCols(rail) {
    var seen = {}, cols = [];
    Array.prototype.forEach.call(rail.children, function (c) {
      if (!c.offsetParent || seen[c.offsetLeft]) return;
      seen[c.offsetLeft] = 1;
      cols.push({ l: c.offsetLeft, w: c.offsetWidth });
    });
    return cols.sort(function (a, b) { return a.l - b.l; });
  }
  function railStep(rail, dir) {
    var cols = railCols(rail);
    if (!cols.length) return;
    var pad = cols[0].l, view = rail.clientWidth - 2 * pad, max = rail.scrollWidth - rail.clientWidth, x = rail.scrollLeft, to = -1, i;
    if (dir > 0) {
      // the first tile not wholly in view moves to the margin
      for (i = 0; i < cols.length && to < 0; i++) { if (cols[i].l - pad + cols[i].w > x + view + 2) to = i; }
      if (to < 0) to = cols.length - 1;
    } else {
      // the first whole tile in view, minus 3
      for (i = 0; i < cols.length && to < 0; i++) { if (cols[i].l - pad >= x - 2) to = i; }
      to = Math.max(0, (to < 0 ? cols.length - 1 : to) - 3);
    }
    // snapping off while the arrow's slide runs (iPhone Safari can fight a smooth scroll on a snapping row)
    rail.style.scrollSnapType = 'none';
    clearTimeout(rail.agscSnap);
    rail.agscSnap = setTimeout(function () { rail.style.scrollSnapType = ''; }, 700);
    rail.scrollTo({ left: Math.max(0, Math.min(max, cols[to].l - pad)), behavior: 'smooth' });
  }

  /* ---------- the size cards: float over, fade in and out ---------- */
  function setCard(card, btn, on) {
    if (!card) return;
    card.classList.toggle('is-open', on);
    card.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function closeCards() {
    setCard($('.agsc-card', root), $('.agsc-i', root), false);
    setCard(pageCard, pageI, false);
    var c = $('.agsc-catch', root); if (c) c.classList.remove('is-on');
  }

  /* ---------- presses: every one drives the page's own control ---------- */
  function pressAdd() {
    if (oosShown()) { var n = oosBox && oosBox.querySelector('[data-agbis-open]'); if (n) n.click(); return; }
    if (!atcBtn.disabled) atcBtn.click();
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, .agsc-dim, .agsc-catch');
    if (!t || !root.contains(t)) return;
    if (t.classList.contains('agsc-picks')) { if (HAS_SHEET) openSheet(); return; }
    if (t.classList.contains('agsc-add')) { pressAdd(); return; }
    if (t.classList.contains('agsc-add2')) { closeSheet(); setTimeout(pressAdd, 60); return; }
    if (t.classList.contains('agsc-x') || t.classList.contains('agsc-dim')) { closeSheet(); return; }
    if (t.classList.contains('agsc-catch')) { closeCards(); return; }
    if (t.classList.contains('agsc-i')) {
      var card = $('.agsc-card', root), on = !card.classList.contains('is-open');
      setCard(card, t, on);
      $('.agsc-catch', root).classList.toggle('is-on', on);
      return;
    }
    if (t.classList.contains('agsc-card-x')) { closeCards(); return; }
    if (t.classList.contains('agsc-chip')) {
      var v = t.getAttribute('data-v');
      if (sizeSel && sizeSel.value !== v) { sizeSel.value = v; sizeSel.dispatchEvent(new Event('change', { bubbles: true })); }
      sync();
      return;
    }
    if (t.classList.contains('agsc-ret')) {
      // Click the radio itself, not its label: a label click focuses the radio and the browser jumps to it.
      var l = retLabels()[+t.getAttribute('data-i')], input = l && l.querySelector('input');
      quiet(900);
      if (input && !input.checked) input.click();
      keepPhoto();
      sync();
      return;
    }
    if (t.classList.contains('agsc-fin--mine')) {
      // pick the custom finish again: its own tile does that (agcf selectCustomSide); the sheet stays open
      var gh = $('.agcf-ghost');
      quiet(1200);
      if (gh && !customOn()) gh.click();
      keepPhoto();
      sync();
      return;
    }
    if (t.classList.contains('agsc-fin--custom')) {
      // + CUSTOM: close the sheet, go to Finishing, open the chooser (never re-apply a custom finish here)
      closeSheet();
      var fs = $('[data-finishing-section]') || $('.agcf-ghost');
      if (fs) {
        var hdr = $('.section_navbar');
        window.scrollTo({ top: Math.max(0, fs.getBoundingClientRect().top + window.pageYOffset - (hdr ? hdr.offsetHeight : 48) - 12), behavior: 'smooth' });
      }
      setTimeout(openChooser, 120);
      return;
    }
    if (t.classList.contains('agsc-fin')) {
      var c = finCards()[+t.getAttribute('data-i')];
      quiet(900);
      // a one-finish card is only pressed to leave a custom finish (agcf then goes back to the stock finish)
      if (c && (!isPicked(c) || customOn())) c.click();
      keepPhoto();
      sync();
      return;
    }
    if (t.classList.contains('agsc-qm') || t.classList.contains('agsc-qp')) {
      var real = $(t.classList.contains('agsc-qm') ? '.qty-minus' : '.qty-plus', atcWrap);
      if (real) real.click();
      else if (qtyInput) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (t.classList.contains('agsc-qm') ? -1 : 1));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
    }
  });
  if (pageI) {
    // Computers with a mouse: the card shows while the pointer is on the i (or the card) and fades 120ms after it
    // leaves, like the collection filter's i. Touch: a tap toggles it, a tap elsewhere or the X closes it.
    var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
    var hideT = null;
    var showP = function () { clearTimeout(hideT); setCard(pageCard, pageI, true); };
    var hideP = function () { clearTimeout(hideT); hideT = setTimeout(function () { setCard(pageCard, pageI, false); }, 120); };
    pageI.addEventListener('mouseenter', function () { if (HOVER.matches) showP(); });
    pageI.addEventListener('mouseleave', function () { if (HOVER.matches) hideP(); });
    pageCard.addEventListener('mouseenter', function () { if (HOVER.matches) clearTimeout(hideT); });
    pageCard.addEventListener('mouseleave', function () { if (HOVER.matches) hideP(); });
    pageI.addEventListener('focus', function () { if (HOVER.matches) showP(); });
    pageI.addEventListener('blur', function () { if (HOVER.matches) hideP(); });
    pageI.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (HOVER.matches) { showP(); return; }
      setCard(pageCard, pageI, !pageCard.classList.contains('is-open'));
    });
    pageCard.addEventListener('click', function (e) { if (e.target.closest('.agsc-card-x')) setCard(pageCard, pageI, false); });
    document.addEventListener('click', function (e) {
      if (pageCard.classList.contains('is-open') && !pageCard.contains(e.target) && e.target !== pageI && !pageI.contains(e.target)) setCard(pageCard, pageI, false);
    }, true);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if ($('.agsc-card.is-open')) { closeCards(); return; }
    closeSheet();
  });

  /* ---------- "Change selection?" on a phone opens the chooser but doesn't jump into its search box ----------
     agcf.js focuses the search input after opening the chooser, which pops the keyboard and scrolls to it. For that
     one click the input's focus() does nothing (Ansen, 2026-10-17). */
  document.addEventListener('click', function (e) {
    if (!MQ.matches || !e.target || !e.target.closest || !e.target.closest('[data-agcf-change]')) return;
    var si = $('.agcf-search input');
    if (!si) return;
    si.focus = function () {};
    setTimeout(function () { try { delete si.focus; } catch (x) {} }, 0);
  }, true);

  /* ---------- watch the page ---------- */
  document.addEventListener('change', function (e) {
    if (e.target && (e.target === vidInput || (e.target.classList && e.target.classList.contains('product-variant-option')) || e.target === qtyInput)) sync();
  }, true);
  if (qtyInput) qtyInput.addEventListener('input', sync);
  var mo = new MutationObserver(sync);
  [atcBtn, oosBox, $('[data-agcf-atc-sub]'), document.getElementById('product-main-price'), $('[data-finishing-section]'), $('[data-agcf-r6]')].forEach(function (n) {
    if (n) mo.observe(n, { attributes: true, childList: true, subtree: true, characterData: true });
  });
  if (sizeSel) {
    new MutationObserver(function () { if (st.sheet) buildSheet(); else sync(); }).observe(sizeSel, { childList: true });
  }

  function onMQ() {
    html.classList.toggle('agsc-m', MQ.matches);
    if (!MQ.matches) closeSheet();
    sync();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', onMQ); else if (MQ.addListener) MQ.addListener(onMQ);
  onMQ();
  if (sheet) buildSheet();
})();
